import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';


const themeChange = {
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
}
// A custom theme for this app
const theme = createMuiTheme();

export default theme;